import React, { useState, useEffect } from "react";
import { getStoreMetaData } from '../../../apis/requests';
import store from "../../redux/store";
import { setShowSplash, setStoreData, setStoreMetaData } from "../../redux/reducer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import config from './../../../config/config.json';
const Splash = () => {
    const [showMaintenance, setShowMaintenance] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        loadGetStoreMetaData();
    }, []);
    const loadGetStoreMetaData = async () => {
        try {
            const res = await getStoreMetaData();
            if (res.data.code === 'UNDER_MAINTENANCE') {
                store.dispatch(setStoreData(res.data.storeData));
                store.dispatch(setStoreMetaData(res.data.metaData));
                setShowMaintenance(true);
            } else {
                store.dispatch(setStoreData(res.data.storeData));
                store.dispatch(setStoreMetaData(res.data.metaData));
                store.dispatch(setShowSplash(false));
            }
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div className='flex items-center justify-center h-screen'
            style={{
                backgroundColor: config.splash_bg,
            }}
        >
            <div>
                <div className="flex content-center">

                    <img src={config.footer_logo} alt="logo 2" className="w-50" />
                </div>
                {
                    showMaintenance &&
                    <div className="text-center mt-5">
                        <h3 className="py-3 text-white" >{t('site_under_maintenance')}</h3>
                        <Link className="text-white" to='/admin/login'>{t('login')}</Link>

                    </div>
                }
                {
                    !showMaintenance &&
                    <div>
                        <section className="dots-container mt-5">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                        </section>
                    </div>
                }
            </div>
        </div>
    );
}
export default Splash;